import styled from 'styled-components';

export const SidePanelContainer = styled.div<{ $borderDirection: 'left' | 'right' }>`
	min-width: 24.25rem;
	max-width: 28.25rem;
	padding: 0.5rem;
	border-left: ${({ $borderDirection }) =>
		$borderDirection === 'left' ? '1px solid var(--Colour-greys-4, #d3d8da)' : 'none'};
	border-right: ${({ $borderDirection }) =>
		$borderDirection === 'right' ? '1px solid var(--Colour-greys-4, #d3d8da)' : 'none'};
`;

export const MiddleContainer = styled.div`
	display: flex;
	padding: 1rem;
	width: 100%;
	flex-direction: column;
	align-items: center;
`;

export const LinkUploadContainer = styled.div`
	width: 100%;
	margin-top: 1rem;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.5rem;
	margin-bottom: 0.5rem;
`;
